import { Add, Delete } from '@mui/icons-material';
import { Box, Button, Grid, IconButton, TextField } from '@mui/material';
import { useEffect } from 'react';
import { Control, Controller, useFieldArray } from 'react-hook-form';

interface QualificationsProps {
    control: Control<any, any>
    maxHeight?: string;
}

export const QualificationsForm = ( { control, maxHeight }: QualificationsProps ) => {
    /* ******************** Hooks ******************** */
    const { fields, append, remove } = useFieldArray({
        // @ts-ignore
        name: 'qualifications',
        control
    })
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    useEffect(()=>{
        if (fields.length === 0) append('');
    },[])
    /* ******************** JSX ******************** */
    return (
        <Grid maxHeight={maxHeight ?? '502px'} overflow={'auto'}>
            <Grid item xs display={"flex"} flexDirection={"column"} gap={1} >
                    {
                        fields.map( (field, index) => (
                            <Grid key={field.id} item xs display={"flex"} flexDirection={"column"} gap={1}>
                                <Grid display={"flex"} flexDirection={"row"} gap={2}> 
                                    <Controller 
                                        name={`qualifications.${index}`}
                                        control={control}
                                        rules={{required: true}}
                                        render={({ field }) =>( 
                                            <TextField
                                                {...field}
                                                multiline
                                                placeholder='Description of qualification'
                                                sx={{flex: 12}}
                                            />
                                        )}                                    
                                    /> 
                                    <Grid item display={"flex"} flex={1} flexDirection={"row"} alignItems={'center'} justifyContent={'flex-end'} gap={1}>
                                        <Box>
                                            <IconButton onClick={ () => remove(index)}>
                                                <Delete color='error'/>
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                </Grid>    
                            </Grid>
                        ))
                    }
                    <Grid item display={"flex"} flexDirection={"row"} >
                            <Button color='primary'  onClick={ () => append('')} >
                                <Add fontSize='small' sx={{marginRight: 0.5}}/>Add qualification
                            </Button> 
                    </Grid>
            </Grid>
        </Grid>
    )
}